import { useRef } from "react";
import { useClickHandler } from "./hooks/useClickHandler";
import { useHoldHandler } from "./hooks/useHoldHandler";

interface ITapTrackerProps {
  children: React.ReactNode;
  onTap: (clicks: number) => void;
  onHold?: () => void;
  onRelease?: () => void;
}

export const TapTracker = (props: ITapTrackerProps) => {
  const { children, onTap, onHold, onRelease } = props;
  const isHolding = useRef<boolean>(false);
  const clickHandler = useClickHandler({ onTap, isHolding });
  const { handleTouchStart, handleTouchEnd } = useHoldHandler({ onHold, onRelease, isHolding });

  return (
    <div
      className="TapTracker"
      onClick={clickHandler}
      {...(onHold || onRelease ? {
        onTouchStart: handleTouchStart,
        onTouchEnd: handleTouchEnd
      } : {})}
    >
      { children }
    </div>
  );
};
